<script type="ts">
  import { v4 as uuidv4 } from "uuid";
  import Plus from "svelte-material-icons/Plus.svelte";

  import { gameState } from "../store";

  const onStartNewGame = () => {
    gameState.update((_) => {
      return {
        currentGame: -1,
        draft: {
          id: uuidv4(),
          // name: "tester",
          date: Date.now().toString(),
          rounds: 0,
          players: [],
        },
      };
    });
  };
  console.log($gameState.draft?.date);
</script>

<button
  class="fixed z-30 gap-2 btn bottom-4 right-4 btn-primary"
  on:click={onStartNewGame}
>
  <Plus class="w-5 h-5" />
  Neue Runde
</button>
